import { render, staticRenderFns } from "./RiepilogoPrenotazioni.vue?vue&type=template&id=4f64f465&"
import script from "./RiepilogoPrenotazioni.vue?vue&type=script&lang=js&"
export * from "./RiepilogoPrenotazioni.vue?vue&type=script&lang=js&"
import style0 from "./RiepilogoPrenotazioni.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports